import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { AiOutlineEye } from "react-icons/ai";
import { BsChevronDown, BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import {
    ButtonHeading,
    CommonInput,
    CustomPagination,
    CustomSelect,
} from "components";
import BootstrapTable from "components/BootstrapTable";
import constants, { Images } from "constants";
import { utils } from "helper";
import { getfastagListApi } from "_services";
import { StorageServices } from "utils";
import "./Fastags.css";
import useDocumentTitle from "hooks/useDocumentTitle";
import { constant } from "constants";

const Fastags = () => {
    // Constants
    const ITEMS_PER_PAGE = 25;
    const DEBOUNCE_DELAY = 500;
    const CompanyId = StorageServices?.getCompanyId();
    useDocumentTitle("Fastags | T360");

    // Initial filter object
    const initialFilterObj = {
        company_id: CompanyId,
        fastag_status: null,
        search: "",
        limit: ITEMS_PER_PAGE,
        offset: 1,
        fastag_status:null,
        is_auto_recharge:null
    };

    // State management
    const [filter, setFilter] = useState(initialFilterObj);
    const [searchInput, setSearchInput] = useState("");
    const [fastagList, setFastagList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const navigate = useNavigate();
    const isInitialMount = useRef(true);
    const [recordDetails, setRecordDetails] = useState({})
    // Table columns configuration
    const columns = [
        { header: "Sr. No", accessor: "sn" },
        { header: "Fastag Added On", accessor: "addition_date" },
        { header: "Fastag Number", accessor: "fastag_number" },
        { header: "Last Activity", accessor: "updatedAt" },
        { header: "Balance", accessor: "balance" },
        { header: "Status", accessor: "fastag_status" },
        { header: "Tags", accessor: "fastag_tags" },
        { header: "Assigned", accessor: "assigned_to_vehicle" },
    ];

    // Debounce effect for search
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        const delayTimer = setTimeout(() => {
            setFilter((prev) => ({
                ...prev,
                search: searchInput,
                offset: 1,
            }));
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(delayTimer);
    }, [searchInput]);

    // Effect for fetching data
    useEffect(() => {
        fetchFastagList();
    }, [filter]);

    // API call
    const fetchFastagList = async () => {
        setLoading(true);
        try {
            const res = await getfastagListApi({
                ...filter,
                firm_id: StorageServices?.getFirmId() || ""
            });

            if (res?.data) {
                setFastagList(res.data?.list);
                setTotalItems(res.pagination?.total_record);
                setRecordDetails(res?.data)
            }
        } catch (error) {
            console.error("Error fetching fastag list:", error);
            setFastagList([]);
        } finally {
            setLoading(false);
        }
    };


    const handleReset = () => {
        setFilter(initialFilterObj);
        setSearchInput("");
    };

    const handlePageChange = (page) => {
        setFilter((prev) => ({ ...prev, offset: page }));
    };

    // Transform data for table rows
    const rowListData = (data, offset = 0) => {
        return data?.map((item, i) => ({
            ...item,
            sn: offset + i + 1,
            serial: (
                <React.Fragment>
                    <div className="signDropdown">
                        <button className="dropbtn11">
                            <BsThreeDotsVertical />
                        </button>
                        <div className="dropdownContent">
                            <Link
                                className="_avPointer"
                                style={{ textDecoration: "none" }}
                            >
                                <span className="_samAnchor">
                                    <span className="viewIcon_avt">
                                        <AiOutlineEye />
                                    </span>
                                    &nbsp; View
                                </span>
                            </Link>
                            <Link className="_avPointer" style={{ textDecoration: "none" }}>
                                <span className="_samAnchor">
                                    <span className="viewIcon_avt">
                                        <FiEdit />
                                    </span>
                                    &nbsp; Edit
                                </span>
                            </Link>
                            <div className="_avPointer">
                                <span className="_samAnchor">
                                    <span className="deleteIcon_avt">
                                        <FaRegTrashCan color="red" />
                                    </span>
                                    Delete
                                </span>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ),
            addition_date: (
                <React.Fragment>
                    {item?.addition_date
                        ? utils?.formatUiDateTime(item?.addition_date)
                        : "-"}
                </React.Fragment>
            ),
            assigned_to_company: (
                <React.Fragment>
                    <div className="">
                        {item?.assigned_to_company
                            ? item.assigned_to_company?.company
                            : "+ Assign to Company"}
                    </div>
                </React.Fragment>
            ),
            assigned_to_vehicle: (
                <React.Fragment>
                    <div className="imgSel_box">
                        {item?.assigned_to_vehicle
                            ? item.assigned_to_vehicle?.vehicle_no
                            : "+ Assign to Vehicle"}
                    </div>
                </React.Fragment>
            ),
            balance: (
                <React.Fragment>
                    <div className="imgSel_box">{item?.balance ? item.balance : "-"}</div>
                </React.Fragment>
            ),
            fastag_tags: (
                <React.Fragment>
                    <div className="imgSel_box">
                        {item?.fastag_tags ? item.fastag_tags : "-"}
                    </div>
                </React.Fragment>
            ),
            fastag_status: (
                <React.Fragment>
                    <div className="imgSel_box">
                        {item?.fastag_status === 1 ? "Active" : "Deactivated"}
                    </div>
                </React.Fragment>
            ),
            fastag_number: (
                <React.Fragment>
                    <div className="imgSel_box" onClick={() => navigate(`/fastag_details/${item?.fastag_number}`)} style={{ color: "blue" }}>
                        {item?.fastag_number ? item.fastag_number : "-"}

                    </div>
                    <div className="__fastNumber">
                        <p></p>
                    </div>
                </React.Fragment>
            ),
            updatedAt: (
                <React.Fragment>
                    {item?.updatedAt ? utils?.formatUiDateTime(item?.updatedAt) : "-"}
                </React.Fragment>
            ),
        }));
    };

    return (
        <>
            <ButtonHeading title="Fastag" />

            <div className="__companyPage_mainBx">
                {/* Filters Section */}
                <div
                    className="__companyPage_filterRow"
                    style={{ borderBottom: "0px", marginBottom: "0px" }}
                >
                    <div style={{ flex: "0 0 289px" }}>
                        <CommonInput
                            placeholder="Search Vehicle Number/ Fastag Number"
                            label="Search Vehicle Number/ Fastag Number"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                    </div>
                    <div >
                        <CustomSelect
                            label="Fastag Status"
                            options={constant?.FASTAG_STATUS_OPTIONS}
                            placeholder="Select Status"
                           onSelect={(data) => {
                                setFilter((pre)=>({...pre,fastag_status:data?.value}));
                            }}
                            value={constant?.FASTAG_STATUS_OPTIONS?.find(
                                (i) => i?.value == filter?.fastag_status
                            )}
                          
                        />
                    </div>
                     <div >
                        <CustomSelect
                            label="Auto Recharge"
                            options={constant?.AUTO_RECHARGE_OPTIONS}
                            placeholder="Select Auto Recharge"
                           
                            onSelect={(data) => {
                                setFilter((pre)=>({...pre,is_auto_recharge:data?.value}));
                            }}
                            value={constant?.AUTO_RECHARGE_OPTIONS?.find(
                                (i) => i?.value == filter?.is_auto_recharge
                            )}
                           
                        />
                    </div>
                    <div className="__onboarded_dropDown">
                        <div className="dropdown">
                            <button
                                className="btn btn-secondary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <div className="__srtTxt">
                                    Last Activity <BsChevronDown />
                                </div>
                                <div className="__srtIco">
                                    <img src={Images?.SORT_ICON?.default} alt="sort" />
                                </div>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a className="dropdown-item-fastag" href="#">
                                        Action
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item-fastag" href="#">
                                        Another action
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item-fastag" href="#">
                                        Something else here
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <button
                        className="anime-btn __reSet_btn"
                        // disabled={!searchInput || !}
                        onClick={handleReset}
                        // style={{
                        //     backgroundColor: !searchInput ? "#ccc" : "", // gray when disabled
                        //     color: !searchInput ? "#666" : "white",
                        //     cursor: !searchInput ? "not-allowed" : "pointer",
                        //     border: "none",
                        //     padding: "8px 16px",
                        //     borderRadius: "6px",
                        //     transition: "all 0.3s ease",
                        // }}

                        style={{
                            backgroundColor:  "", // gray when disabled
                            color:  "white",
                            cursor:  "pointer",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            transition: "all 0.3s ease",
                        }}
                    >
                        Reset
                    </button>

                </div>

                {/* Statistics Section */}
                <div className="__fastag__count__bx">
                    <div className="__fastag__count__inrbx">
                        <span>No. of Fastags</span>
                        <span className="__fastag__count__display">{recordDetails?.total_record || 0}</span>
                    </div>
                    <div className="__fastag__count__inrbx">
                        <span>Total Debit</span>
                        <span className="__fastag__count__display">{`₹ ${Number(recordDetails?.total_debit || 0).toFixed(2)}`}</span>
                    </div>
                    <div className="__fastag__count__inrbx">
                        <span>Total Credit</span>
                        <span className="__fastag__count__display">{`₹ ${Number(recordDetails?.total_credit || 0).toFixed(2)}`}</span>
                    </div>
                </div>

                {/* Table Section */}
                <div className="_tabWith_outTab">
                    <BootstrapTable
                        tableClass="companyTable_bx"
                        columns={columns}
                        data={rowListData(fastagList?.length > 0 ? fastagList : [], (filter.offset - 1) * ITEMS_PER_PAGE)}
                        isLoading={loading}
                    />
                    <div className="paginationFt_avt">
                        <CustomPagination
                            totalItems={totalItems || 1}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Fastags;